import styled from '@emotion/styled';

/**
 * Add a semantic horizontal rule element.
 */

interface DividerProps {
  margin?: string;
  width?: string;
}

const Divider = styled.hr<DividerProps>`
  border: 0;
  height: 1px;
  background: ${({ theme }) => theme.color.gray200};
  margin: 0;
  width: ${({ width }) => width || '100%'};
  margin: ${({ margin }) => margin || '0'};
`;

export default Divider;
